import _toConsumableArray from "C:\\Code\\fiducius-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "C:\\Code\\fiducius-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "C:\\Code\\fiducius-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _extends from "C:\\Code\\fiducius-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/extends";
import _get from "C:\\Code\\fiducius-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _createClass from "C:\\Code\\fiducius-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Code\\fiducius-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Code\\fiducius-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Code\\fiducius-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "C:\\Code\\fiducius-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "C:\\Code\\fiducius-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";
import _regeneratorRuntime from "C:\\Code\\fiducius-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Code\\fiducius-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\Code\\fiducius-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _defineProperty from "C:\\Code\\fiducius-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectSpread from "C:\\Code\\fiducius-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import { each as ge, useIsomorphicLayoutEffect as an } from "@react-spring/shared";
import { is as K, toArray as $t, eachProp as dt, getFluidValue as Zt, isAnimatedString as en, Globals as tn } from "@react-spring/shared";

function I(t) {
  for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    e[_key - 1] = arguments[_key];
  }

  return K.fun(t) ? t.apply(void 0, e) : t;
}

var te = function te(t, e) {
  return t === !0 || !!(e && t && (K.fun(t) ? t(e) : $t(t).includes(e)));
},
    et = function et(t, e) {
  return K.obj(t) ? e && t[e] : t;
};

var ke = function ke(t, e) {
  return t.default === !0 ? t[e] : t.default ? t.default[e] : void 0;
},
    nn = function nn(t) {
  return t;
},
    ne = function ne(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : nn;
  var n = rn;
  t.default && t.default !== !0 && (t = t.default, n = Object.keys(t));
  var r = {};

  for (var _i = 0; _i < n.length; _i++) {
    var o = n[_i];
    var s = e(t[o], o);
    K.und(s) || (r[o] = s);
  }

  return r;
},
    rn = ["config", "onProps", "onStart", "onChange", "onPause", "onResume", "onRest"],
    on = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  keys: 1,
  callId: 1,
  parentId: 1
};

function sn(t) {
  var e = {},
      n = 0;
  if (dt(t, function (r, o) {
    on[o] || (e[o] = r, n++);
  }), n) return e;
}

function de(t) {
  var e = sn(t);

  if (e) {
    var n = {
      to: e
    };
    return dt(t, function (r, o) {
      return o in e || (n[o] = r);
    }), n;
  }

  return _objectSpread({}, t);
}

function me(t) {
  return t = Zt(t), K.arr(t) ? t.map(me) : en(t) ? tn.createStringInterpolator({
    range: [0, 1],
    output: [t, t]
  })(1) : t;
}

function Ue(t) {
  for (var e in t) {
    return !0;
  }

  return !1;
}

function Ee(t) {
  return K.fun(t) || K.arr(t) && K.obj(t[0]);
}

function xe(t, e) {
  var _t$ref;

  (_t$ref = t.ref) !== null && _t$ref !== void 0 && _t$ref.delete(t), e === null || e === void 0 ? void 0 : e.delete(t);
}

function he(t, e) {
  var _t$ref2;

  e && t.ref !== e && ((_t$ref2 = t.ref) !== null && _t$ref2 !== void 0 && _t$ref2.delete(t), e.add(t), t.ref = e);
}

function wr(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e3;
  an(function () {
    if (e) {
      var r = 0;
      ge(t, function (o, s) {
        var i = o.current;

        if (i.length) {
          var a = n * e[s];
          isNaN(a) ? a = r : r = a, ge(i, function (u) {
            ge(u.queue, function (p) {
              var f = p.delay;

              p.delay = function (d) {
                return a + I(f || 0, d);
              };
            });
          }), o.start();
        }
      });
    } else {
      var _r2 = Promise.resolve();

      ge(t, function (o) {
        var s = o.current;

        if (s.length) {
          var i = s.map(function (a) {
            var u = a.queue;
            return a.queue = [], u;
          });
          _r2 = _r2.then(function () {
            return ge(s, function (a, u) {
              return ge(i[u] || [], function (p) {
                return a.queue.push(p);
              });
            }), Promise.all(o.start());
          });
        }
      });
    }
  });
}

import { is as Qn } from "@react-spring/shared";
import { useContext as Mn, useMemo as Xe, useRef as Nt } from "react";
import { is as jn, each as Ye, usePrev as Dt, useOnce as Nn, useForceUpdate as Dn, useIsomorphicLayoutEffect as qn } from "@react-spring/shared";
import { is as R, raf as ve, each as At, isEqual as Y, toArray as Rt, eachProp as Pn, frameLoop as Tn, flushCalls as Qe, getFluidValue as ie, isAnimatedString as xn, Globals as bn, callFluidObservers as An, hasFluidValue as Se, addFluidObserver as Rn, removeFluidObserver as vn, getFluidObservers as vt } from "@react-spring/shared";
import { AnimatedValue as Cn, AnimatedString as Ct, getPayload as In, getAnimated as ae, setAnimated as Vn, getAnimatedType as It } from "@react-spring/animated";
import { is as re, easings as un } from "@react-spring/shared";
var mt = {
  default: {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
};

var tt = _objectSpread({}, mt.default, {
  mass: 1,
  damping: 1,
  easing: un.linear,
  clamp: !1
}),
    we = function we() {
  _classCallCheck(this, we);

  _defineProperty(this, "tension", void 0);

  _defineProperty(this, "friction", void 0);

  _defineProperty(this, "frequency", void 0);

  _defineProperty(this, "damping", void 0);

  _defineProperty(this, "mass", void 0);

  _defineProperty(this, "velocity", 0);

  _defineProperty(this, "restVelocity", void 0);

  _defineProperty(this, "precision", void 0);

  _defineProperty(this, "progress", void 0);

  _defineProperty(this, "duration", void 0);

  _defineProperty(this, "easing", void 0);

  _defineProperty(this, "clamp", void 0);

  _defineProperty(this, "bounce", void 0);

  _defineProperty(this, "decay", void 0);

  _defineProperty(this, "round", void 0);

  Object.assign(this, tt);
};

function gt(t, e, n) {
  n && (n = _objectSpread({}, n), ht(n, e), e = _objectSpread({}, n, e)), ht(t, e), Object.assign(t, e);

  for (var i in tt) {
    t[i] == null && (t[i] = tt[i]);
  }

  var r = t.frequency,
      o = t.damping,
      s = t.mass;
  return re.und(r) || (r < .01 && (r = .01), o < 0 && (o = 0), t.tension = Math.pow(2 * Math.PI / r, 2) * s, t.friction = 4 * Math.PI * o * s / r), t;
}

function ht(t, e) {
  if (!re.und(e.decay)) t.duration = void 0;else {
    var n = !re.und(e.tension) || !re.und(e.friction);
    (n || !re.und(e.frequency) || !re.und(e.damping) || !re.und(e.mass)) && (t.duration = void 0, t.decay = void 0), n && (t.frequency = void 0);
  }
}

var yt = [],
    Le = function Le() {
  _classCallCheck(this, Le);

  _defineProperty(this, "changed", !1);

  _defineProperty(this, "values", yt);

  _defineProperty(this, "toValues", null);

  _defineProperty(this, "fromValues", yt);

  _defineProperty(this, "to", void 0);

  _defineProperty(this, "from", void 0);

  _defineProperty(this, "config", new we());

  _defineProperty(this, "immediate", !1);
};

import { is as pn, raf as St, Globals as ln } from "@react-spring/shared";

function Me(t, _ref) {
  var e = _ref.key,
      n = _ref.props,
      r = _ref.defaultProps,
      o = _ref.state,
      s = _ref.actions;
  return new Promise(function (i, a) {
    var _n$cancel;

    var u,
        p,
        f = te((_n$cancel = n.cancel) !== null && _n$cancel !== void 0 ? _n$cancel : r === null || r === void 0 ? void 0 : r.cancel, e);
    if (f) b();else {
      pn.und(n.pause) || (o.paused = te(n.pause, e));
      var c = r === null || r === void 0 ? void 0 : r.pause;
      c !== !0 && (c = o.paused || te(c, e)), u = I(n.delay || 0, e), c ? (o.resumeQueue.add(m), s.pause()) : (s.resume(), m());
    }

    function d() {
      o.resumeQueue.add(m), o.timeouts.delete(p), p.cancel(), u = p.time - St.now();
    }

    function m() {
      u > 0 && !ln.skipAnimation ? (o.delayed = !0, p = St.setTimeout(b, u), o.pauseQueue.add(d), o.timeouts.add(p)) : b();
    }

    function b() {
      o.delayed && (o.delayed = !1), o.pauseQueue.delete(d), o.timeouts.delete(p), t <= (o.cancelId || 0) && (f = !0);

      try {
        s.start(_objectSpread({}, n, {
          callId: t,
          cancel: f
        }), i);
      } catch (c) {
        a(c);
      }
    }
  });
}

import { is as je, raf as cn, flush as fn, eachProp as dn, Globals as Pt } from "@react-spring/shared";

var be = function be(t, e) {
  return e.length == 1 ? e[0] : e.some(function (n) {
    return n.cancelled;
  }) ? q(t.get()) : e.every(function (n) {
    return n.noop;
  }) ? nt(t.get()) : E(t.get(), e.every(function (n) {
    return n.finished;
  }));
},
    nt = function nt(t) {
  return {
    value: t,
    noop: !0,
    finished: !0,
    cancelled: !1
  };
},
    E = function E(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  return {
    value: t,
    finished: e,
    cancelled: n
  };
},
    q = function q(t) {
  return {
    value: t,
    cancelled: !0,
    finished: !1
  };
};

function De(t, e, n, r) {
  var o = e.callId,
      s = e.parentId,
      i = e.onRest,
      a = n.asyncTo,
      u = n.promise;
  return !s && t === a && !e.reset ? u : n.promise = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var p, f, d, m, b, c, P, l;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            n.asyncId = o, n.asyncTo = t;
            p = ne(e, function (l, h) {
              return h === "onRest" ? void 0 : l;
            }), m = new Promise(function (l, h) {
              return f = l, d = h;
            }), b = function b(l) {
              var h = o <= (n.cancelId || 0) && q(r) || o !== n.asyncId && E(r, !1);
              if (h) throw l.result = h, d(l), l;
            }, c = function c(l, h) {
              var g = new Ae(),
                  x = new Ne();
              return _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee() {
                var S, A;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!Pt.skipAnimation) {
                          _context.next = 2;
                          break;
                        }

                        throw oe(n), x.result = E(r, !1), d(x), x;

                      case 2:
                        b(g);
                        S = je.obj(l) ? _objectSpread({}, l) : _objectSpread({}, h, {
                          to: l
                        });
                        S.parentId = o, dn(p, function (V, _) {
                          je.und(S[_]) && (S[_] = V);
                        });
                        _context.next = 7;
                        return r.start(S);

                      case 7:
                        A = _context.sent;
                        b(g);
                        _context.t0 = n.paused;

                        if (!_context.t0) {
                          _context.next = 13;
                          break;
                        }

                        _context.next = 13;
                        return new Promise(function (V) {
                          n.resumeQueue.add(V);
                        });

                      case 13:
                        return _context.abrupt("return", A);

                      case 14:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }))();
            };

            if (!Pt.skipAnimation) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt("return", (oe(n), E(r, !1)));

          case 4:
            _context3.prev = 4;
            je.arr(t) ? l = function () {
              var _ref4 = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee2(h) {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, g;

                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _iteratorNormalCompletion = true;
                        _didIteratorError = false;
                        _iteratorError = undefined;
                        _context2.prev = 3;
                        _iterator = h[Symbol.iterator]();

                      case 5:
                        if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                          _context2.next = 12;
                          break;
                        }

                        g = _step.value;
                        _context2.next = 9;
                        return c(g);

                      case 9:
                        _iteratorNormalCompletion = true;
                        _context2.next = 5;
                        break;

                      case 12:
                        _context2.next = 18;
                        break;

                      case 14:
                        _context2.prev = 14;
                        _context2.t0 = _context2["catch"](3);
                        _didIteratorError = true;
                        _iteratorError = _context2.t0;

                      case 18:
                        _context2.prev = 18;
                        _context2.prev = 19;

                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                          _iterator.return();
                        }

                      case 21:
                        _context2.prev = 21;

                        if (!_didIteratorError) {
                          _context2.next = 24;
                          break;
                        }

                        throw _iteratorError;

                      case 24:
                        return _context2.finish(21);

                      case 25:
                        return _context2.finish(18);

                      case 26:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[3, 14, 18, 26], [19,, 21, 25]]);
              }));

              return function (_x) {
                return _ref4.apply(this, arguments);
              };
            }()(t) : l = Promise.resolve(t(c, r.stop.bind(r)));
            _context3.next = 8;
            return Promise.all([l.then(f), m]);

          case 8:
            P = E(r.get(), !0, !1);
            _context3.next = 22;
            break;

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](4);

            if (!(_context3.t0 instanceof Ae)) {
              _context3.next = 17;
              break;
            }

            P = _context3.t0.result;
            _context3.next = 22;
            break;

          case 17:
            if (!(_context3.t0 instanceof Ne)) {
              _context3.next = 21;
              break;
            }

            P = _context3.t0.result;
            _context3.next = 22;
            break;

          case 21:
            throw _context3.t0;

          case 22:
            _context3.prev = 22;
            o == n.asyncId && (n.asyncId = s, n.asyncTo = s ? a : void 0, n.promise = s ? u : void 0);
            return _context3.finish(22);

          case 25:
            return _context3.abrupt("return", (je.fun(i) && cn.batchedUpdates(function () {
              i(P, r, r.item);
            }), P));

          case 26:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[4, 11, 22, 25]]);
  }))();
}

function oe(t, e) {
  fn(t.timeouts, function (n) {
    return n.cancel();
  }), t.pauseQueue.clear(), t.resumeQueue.clear(), t.asyncId = t.asyncTo = t.promise = void 0, e && (t.cancelId = e);
}

var Ae =
/*#__PURE__*/
function (_Error) {
  _inherits(Ae, _Error);

  function Ae() {
    var _this;

    _classCallCheck(this, Ae);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Ae).call(this, "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise."));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "result", void 0);

    return _this;
  }

  return Ae;
}(_wrapNativeSuper(Error)),
    Ne =
/*#__PURE__*/
function (_Error2) {
  _inherits(Ne, _Error2);

  function Ne() {
    var _this2;

    _classCallCheck(this, Ne);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Ne).call(this, "SkipAnimationSignal"));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "result", void 0);

    return _this2;
  }

  return Ne;
}(_wrapNativeSuper(Error));

import { deprecateInterpolate as mn, frameLoop as hn, FluidValue as gn, Globals as Tt, callFluidObservers as xt } from "@react-spring/shared";
import { getAnimated as yn } from "@react-spring/animated";

var Re = function Re(t) {
  return t instanceof X;
},
    Sn = 1,
    X =
/*#__PURE__*/
function (_gn) {
  _inherits(X, _gn);

  function X() {
    var _getPrototypeOf2;

    var _this3;

    _classCallCheck(this, X);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(X)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this3)), "id", Sn++);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this3)), "_priority", 0);

    return _this3;
  }

  _createClass(X, [{
    key: "get",
    value: function get() {
      var e = yn(this);
      return e && e.getValue();
    }
  }, {
    key: "to",
    value: function to() {
      for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        e[_key3] = arguments[_key3];
      }

      return Tt.to(this, e);
    }
  }, {
    key: "interpolate",
    value: function interpolate() {
      for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        e[_key4] = arguments[_key4];
      }

      return mn(), Tt.to(this, e);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.get();
    }
  }, {
    key: "observerAdded",
    value: function observerAdded(e) {
      e == 1 && this._attach();
    }
  }, {
    key: "observerRemoved",
    value: function observerRemoved(e) {
      e == 0 && this._detach();
    }
  }, {
    key: "_attach",
    value: function _attach() {}
  }, {
    key: "_detach",
    value: function _detach() {}
  }, {
    key: "_onChange",
    value: function _onChange(e) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      xt(this, {
        type: "change",
        parent: this,
        value: e,
        idle: n
      });
    }
  }, {
    key: "_onPriorityChange",
    value: function _onPriorityChange(e) {
      this.idle || hn.sort(this), xt(this, {
        type: "priority",
        parent: this,
        priority: e
      });
    }
  }, {
    key: "priority",
    get: function get() {
      return this._priority;
    },
    set: function set(e) {
      this._priority != e && (this._priority = e, this._onPriorityChange(e));
    }
  }]);

  return X;
}(gn);

var se = Symbol.for("SpringPhase"),
    bt = 1,
    rt = 2,
    ot = 4,
    qe = function qe(t) {
  return (t[se] & bt) > 0;
},
    Q = function Q(t) {
  return (t[se] & rt) > 0;
},
    ye = function ye(t) {
  return (t[se] & ot) > 0;
},
    st = function st(t, e) {
  return e ? t[se] |= rt | bt : t[se] &= ~rt;
},
    it = function it(t, e) {
  return e ? t[se] |= ot : t[se] &= ~ot;
};

var ue =
/*#__PURE__*/
function (_X) {
  _inherits(ue, _X);

  function ue(e, n) {
    var _temp, _this4;

    _classCallCheck(this, ue);

    if ((_temp = _this4 = _possibleConstructorReturn(this, _getPrototypeOf(ue).call(this)), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this4)), "key", void 0), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this4)), "animation", new Le()), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this4)), "queue", void 0), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this4)), "defaultProps", {}), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this4)), "_state", {
      paused: !1,
      delayed: !1,
      pauseQueue: new Set(),
      resumeQueue: new Set(),
      timeouts: new Set()
    }), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this4)), "_pendingCalls", new Set()), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this4)), "_lastCallId", 0), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this4)), "_lastToId", 0), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this4)), "_memoizedDuration", 0), _temp), !R.und(e) || !R.und(n)) {
      var r = R.obj(e) ? _objectSpread({}, e) : _objectSpread({}, n, {
        from: e
      });
      R.und(r.default) && (r.default = !0), _this4.start(r);
    }

    return _possibleConstructorReturn(_this4);
  }

  _createClass(ue, [{
    key: "advance",
    value: function advance(e) {
      var _this5 = this;

      var n = !0,
          r = !1,
          o = this.animation,
          s = o.toValues,
          i = o.config,
          a = In(o.to);
      !a && Se(o.to) && (s = Rt(ie(o.to))), o.values.forEach(function (f, d) {
        if (f.done) return;
        var m = f.constructor == Ct ? 1 : a ? a[d].lastPosition : s[d],
            b = o.immediate,
            c = m;

        if (!b) {
          if (c = f.lastPosition, i.tension <= 0) {
            f.done = !0;
            return;
          }

          var P = f.elapsedTime += e,
              l = o.fromValues[d],
              h = f.v0 != null ? f.v0 : f.v0 = R.arr(i.velocity) ? i.velocity[d] : i.velocity,
              g,
              x = i.precision || (l == m ? .005 : Math.min(1, Math.abs(m - l) * .001));
          if (R.und(i.duration)) {
            if (i.decay) {
              var S = i.decay === !0 ? .998 : i.decay,
                  A = Math.exp(-(1 - S) * P);
              c = l + h / (1 - S) * (1 - A), b = Math.abs(f.lastPosition - c) <= x, g = h * A;
            } else {
              g = f.lastVelocity == null ? h : f.lastVelocity;

              var _S = i.restVelocity || x / 10,
                  _A = i.clamp ? 0 : i.bounce,
                  V = !R.und(_A),
                  _ = l == m ? f.v0 > 0 : l < m,
                  v,
                  w = !1,
                  C = 1,
                  $ = Math.ceil(e / C);

              for (var L = 0; L < $ && (v = Math.abs(g) > _S, !(!v && (b = Math.abs(m - c) <= x, b))); ++L) {
                V && (w = c == m || c > m == _, w && (g = -g * _A, c = m));
                var N = -i.tension * 1e-6 * (c - m),
                    y = -i.friction * .001 * g,
                    T = (N + y) / i.mass;
                g = g + T * C, c = c + g * C;
              }
            }
          } else {
            var _S2 = 1;
            i.duration > 0 && (_this5._memoizedDuration !== i.duration && (_this5._memoizedDuration = i.duration, f.durationProgress > 0 && (f.elapsedTime = i.duration * f.durationProgress, P = f.elapsedTime += e)), _S2 = (i.progress || 0) + P / _this5._memoizedDuration, _S2 = _S2 > 1 ? 1 : _S2 < 0 ? 0 : _S2, f.durationProgress = _S2), c = l + i.easing(_S2) * (m - l), g = (c - f.lastPosition) / e, b = _S2 == 1;
          }
          f.lastVelocity = g, Number.isNaN(c) && (console.warn("Got NaN while animating:", _this5), b = !0);
        }

        a && !a[d].done && (b = !1), b ? f.done = !0 : n = !1, f.setValue(c, i.round) && (r = !0);
      });
      var u = ae(this),
          p = u.getValue();

      if (n) {
        var f = ie(o.to);
        (p !== f || r) && !i.decay ? (u.setValue(f), this._onChange(f)) : r && i.decay && this._onChange(p), this._stop();
      } else r && this._onChange(p);
    }
  }, {
    key: "set",
    value: function set(e) {
      var _this6 = this;

      return ve.batchedUpdates(function () {
        _this6._stop(), _this6._focus(e), _this6._set(e);
      }), this;
    }
  }, {
    key: "pause",
    value: function pause() {
      this._update({
        pause: !0
      });
    }
  }, {
    key: "resume",
    value: function resume() {
      this._update({
        pause: !1
      });
    }
  }, {
    key: "finish",
    value: function finish() {
      var _this7 = this;

      if (Q(this)) {
        var _this$animation = this.animation,
            e = _this$animation.to,
            n = _this$animation.config;
        ve.batchedUpdates(function () {
          _this7._onStart(), n.decay || _this7._set(e, !1), _this7._stop();
        });
      }

      return this;
    }
  }, {
    key: "update",
    value: function update(e) {
      return (this.queue || (this.queue = [])).push(e), this;
    }
  }, {
    key: "start",
    value: function start(e, n) {
      var _this8 = this;

      var r;
      return R.und(e) ? (r = this.queue || [], this.queue = []) : r = [R.obj(e) ? e : _objectSpread({}, n, {
        to: e
      })], Promise.all(r.map(function (o) {
        return _this8._update(o);
      })).then(function (o) {
        return be(_this8, o);
      });
    }
  }, {
    key: "stop",
    value: function stop(e) {
      var _this9 = this;

      var n = this.animation.to;
      return this._focus(this.get()), oe(this._state, e && this._lastCallId), ve.batchedUpdates(function () {
        return _this9._stop(n, e);
      }), this;
    }
  }, {
    key: "reset",
    value: function reset() {
      this._update({
        reset: !0
      });
    }
  }, {
    key: "eventObserved",
    value: function eventObserved(e) {
      e.type == "change" ? this._start() : e.type == "priority" && (this.priority = e.priority + 1);
    }
  }, {
    key: "_prepareNode",
    value: function _prepareNode(e) {
      var _ref5;

      var n = this.key || "",
          r = e.to,
          o = e.from;
      r = R.obj(r) ? r[n] : r, (r == null || Ee(r)) && (r = void 0), o = R.obj(o) ? o[n] : o, o == null && (o = void 0);
      var s = {
        to: r,
        from: o
      };
      return qe(this) || (e.reverse && (_ref5 = [o, r], r = _ref5[0], o = _ref5[1], _ref5), o = ie(o), R.und(o) ? ae(this) || this._set(r) : this._set(o)), s;
    }
  }, {
    key: "_update",
    value: function _update(_ref6, n) {
      var _this10 = this;

      var e = _extends({}, _ref6);

      var r = this.key,
          o = this.defaultProps;
      e.default && Object.assign(o, ne(e, function (a, u) {
        return /^on/.test(u) ? et(a, r) : a;
      })), _t(this, e, "onProps"), Ie(this, "onProps", e, this);

      var s = this._prepareNode(e);

      if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
      var i = this._state;
      return Me(++this._lastCallId, {
        key: r,
        props: e,
        defaultProps: o,
        state: i,
        actions: {
          pause: function pause() {
            ye(_this10) || (it(_this10, !0), Qe(i.pauseQueue), Ie(_this10, "onPause", E(_this10, Ce(_this10, _this10.animation.to)), _this10));
          },
          resume: function resume() {
            ye(_this10) && (it(_this10, !1), Q(_this10) && _this10._resume(), Qe(i.resumeQueue), Ie(_this10, "onResume", E(_this10, Ce(_this10, _this10.animation.to)), _this10));
          },
          start: this._merge.bind(this, s)
        }
      }).then(function (a) {
        if (e.loop && a.finished && !(n && a.noop)) {
          var u = at(e);
          if (u) return _this10._update(u, !0);
        }

        return a;
      });
    }
  }, {
    key: "_merge",
    value: function _merge(e, n, r) {
      var _ref7,
          _this11 = this;

      if (n.cancel) return this.stop(!0), r(q(this));
      var o = !R.und(e.to),
          s = !R.und(e.from);
      if (o || s) if (n.callId > this._lastToId) this._lastToId = n.callId;else return r(q(this));
      var i = this.key,
          a = this.defaultProps,
          u = this.animation,
          p = u.to,
          f = u.from,
          _e$to = e.to,
          d = _e$to === void 0 ? p : _e$to,
          _e$from = e.from,
          m = _e$from === void 0 ? f : _e$from;
      s && !o && (!n.default || R.und(d)) && (d = m), n.reverse && (_ref7 = [m, d], d = _ref7[0], m = _ref7[1], _ref7);
      var b = !Y(m, f);
      b && (u.from = m), m = ie(m);
      var c = !Y(d, p);
      c && this._focus(d);
      var P = Ee(n.to),
          l = u.config,
          h = l.decay,
          g = l.velocity;
      (o || s) && (l.velocity = 0), n.config && !P && gt(l, I(n.config, i), n.config !== a.config ? I(a.config, i) : void 0);
      var x = ae(this);
      if (!x || R.und(d)) return r(E(this, !0));

      var S = R.und(n.reset) ? s && !n.default : !R.und(m) && te(n.reset, i),
          A = S ? m : this.get(),
          V = me(d),
          _ = R.num(V) || R.arr(V) || xn(V),
          v = !P && (!_ || te(a.immediate || n.immediate, i));

      if (c) {
        var L = It(d);
        if (L !== x.constructor) if (v) x = this._set(V);else throw Error("Cannot animate between ".concat(x.constructor.name, " and ").concat(L.name, ", as the \"to\" prop suggests"));
      }

      var w = x.constructor,
          C = Se(d),
          $ = !1;

      if (!C) {
        var _L = S || !qe(this) && b;

        (c || _L) && ($ = Y(me(A), V), C = !$), (!Y(u.immediate, v) && !v || !Y(l.decay, h) || !Y(l.velocity, g)) && (C = !0);
      }

      if ($ && Q(this) && (u.changed && !S ? C = !0 : C || this._stop(p)), !P && ((C || Se(p)) && (u.values = x.getPayload(), u.toValues = Se(d) ? null : w == Ct ? [1] : Rt(V)), u.immediate != v && (u.immediate = v, !v && !S && this._set(p)), C)) {
        var _L2 = u.onRest;
        At(_n, function (y) {
          return _t(_this11, n, y);
        });
        var N = E(this, Ce(this, p));
        Qe(this._pendingCalls, N), this._pendingCalls.add(r), u.changed && ve.batchedUpdates(function () {
          var _u$onStart;

          u.changed = !S, _L2 !== null && _L2 !== void 0 && _L2(N, _this11), S ? I(a.onRest, N) : (_u$onStart = u.onStart) === null || _u$onStart === void 0 ? void 0 : _u$onStart.call(u, N, _this11);
        });
      }

      S && this._set(A), P ? r(De(n.to, n, this._state, this)) : C ? this._start() : Q(this) && !c ? this._pendingCalls.add(r) : r(nt(A));
    }
  }, {
    key: "_focus",
    value: function _focus(e) {
      var n = this.animation;
      e !== n.to && (vt(this) && this._detach(), n.to = e, vt(this) && this._attach());
    }
  }, {
    key: "_attach",
    value: function _attach() {
      var e = 0,
          n = this.animation.to;
      Se(n) && (Rn(n, this), Re(n) && (e = n.priority + 1)), this.priority = e;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      var e = this.animation.to;
      Se(e) && vn(e, this);
    }
  }, {
    key: "_set",
    value: function _set(e) {
      var _this12 = this;

      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var r = ie(e);

      if (!R.und(r)) {
        var o = ae(this);

        if (!o || !Y(r, o.getValue())) {
          var s = It(r);
          !o || o.constructor != s ? Vn(this, s.create(r)) : o.setValue(r), o && ve.batchedUpdates(function () {
            _this12._onChange(r, n);
          });
        }
      }

      return ae(this);
    }
  }, {
    key: "_onStart",
    value: function _onStart() {
      var e = this.animation;
      e.changed || (e.changed = !0, Ie(this, "onStart", E(this, Ce(this, e.to)), this));
    }
  }, {
    key: "_onChange",
    value: function _onChange(e, n) {
      n || (this._onStart(), I(this.animation.onChange, e, this)), I(this.defaultProps.onChange, e, this), _get(_getPrototypeOf(ue.prototype), "_onChange", this).call(this, e, n);
    }
  }, {
    key: "_start",
    value: function _start() {
      var e = this.animation;
      ae(this).reset(ie(e.to)), e.immediate || (e.fromValues = e.values.map(function (n) {
        return n.lastPosition;
      })), Q(this) || (st(this, !0), ye(this) || this._resume());
    }
  }, {
    key: "_resume",
    value: function _resume() {
      bn.skipAnimation ? this.finish() : Tn.start(this);
    }
  }, {
    key: "_stop",
    value: function _stop(e, n) {
      if (Q(this)) {
        st(this, !1);
        var r = this.animation;
        At(r.values, function (s) {
          s.done = !0;
        }), r.toValues && (r.onChange = r.onPause = r.onResume = void 0), An(this, {
          type: "idle",
          parent: this
        });
        var o = n ? q(this.get()) : E(this.get(), Ce(this, e !== null && e !== void 0 ? e : r.to));
        Qe(this._pendingCalls, o), r.changed && (r.changed = !1, Ie(this, "onRest", o, this));
      }
    }
  }, {
    key: "idle",
    get: function get() {
      return !(Q(this) || this._state.asyncTo) || ye(this);
    }
  }, {
    key: "goal",
    get: function get() {
      return ie(this.animation.to);
    }
  }, {
    key: "velocity",
    get: function get() {
      var e = ae(this);
      return e instanceof Cn ? e.lastVelocity || 0 : e.getPayload().map(function (n) {
        return n.lastVelocity || 0;
      });
    }
  }, {
    key: "hasAnimated",
    get: function get() {
      return qe(this);
    }
  }, {
    key: "isAnimating",
    get: function get() {
      return Q(this);
    }
  }, {
    key: "isPaused",
    get: function get() {
      return ye(this);
    }
  }, {
    key: "isDelayed",
    get: function get() {
      return this._state.delayed;
    }
  }]);

  return ue;
}(X);

function Ce(t, e) {
  var n = me(e),
      r = me(t.get());
  return Y(r, n);
}

function at(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t.loop;
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t.to;
  var r = I(e);

  if (r) {
    var o = r !== !0 && de(r),
        s = (o || t).reverse,
        i = !o || o.reset;
    return Pe(_objectSpread({}, t, {
      loop: e,
      default: !1,
      pause: void 0,
      to: !s || Ee(n) ? n : void 0,
      from: i ? t.from : void 0,
      reset: i
    }, o));
  }
}

function Pe(t) {
  var _t2 = t = de(t),
      e = _t2.to,
      n = _t2.from,
      r = new Set();

  return R.obj(e) && Vt(e, r), R.obj(n) && Vt(n, r), t.keys = r.size ? Array.from(r) : null, t;
}

function Ot(t) {
  var e = Pe(t);
  return R.und(e.default) && (e.default = ne(e)), e;
}

function Vt(t, e) {
  Pn(t, function (n, r) {
    return n != null && e.add(r);
  });
}

var _n = ["onStart", "onRest", "onChange", "onPause", "onResume"];

function _t(t, e, n) {
  t.animation[n] = e[n] !== ke(e, n) ? et(e[n], t.key) : void 0;
}

function Ie(t, e) {
  var _t$animation$e, _t$animation, _t$defaultProps$e, _t$defaultProps;

  for (var _len5 = arguments.length, n = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
    n[_key5 - 2] = arguments[_key5];
  }

  (_t$animation$e = (_t$animation = t.animation)[e]) !== null && _t$animation$e !== void 0 && _t$animation$e.call.apply(_t$animation$e, [_t$animation].concat(n)), (_t$defaultProps$e = (_t$defaultProps = t.defaultProps)[e]) === null || _t$defaultProps$e === void 0 ? void 0 : _t$defaultProps$e.call.apply(_t$defaultProps$e, [_t$defaultProps].concat(n));
}

import { is as z, raf as kt, each as pe, noop as Ft, flush as ut, toArray as Ve, eachProp as Ut, flushCalls as On, addFluidObserver as Et } from "@react-spring/shared";

var Fn = ["onStart", "onChange", "onRest"],
    kn = 1,
    le =
/*#__PURE__*/
function () {
  function le(e, n) {
    _classCallCheck(this, le);

    _defineProperty(this, "id", kn++);

    _defineProperty(this, "springs", {});

    _defineProperty(this, "queue", []);

    _defineProperty(this, "ref", void 0);

    _defineProperty(this, "_flush", void 0);

    _defineProperty(this, "_initialProps", void 0);

    _defineProperty(this, "_lastAsyncId", 0);

    _defineProperty(this, "_active", new Set());

    _defineProperty(this, "_changed", new Set());

    _defineProperty(this, "_started", !1);

    _defineProperty(this, "_item", void 0);

    _defineProperty(this, "_state", {
      paused: !1,
      pauseQueue: new Set(),
      resumeQueue: new Set(),
      timeouts: new Set()
    });

    _defineProperty(this, "_events", {
      onStart: new Map(),
      onChange: new Map(),
      onRest: new Map()
    });

    this._onFrame = this._onFrame.bind(this), n && (this._flush = n), e && this.start(_objectSpread({
      default: !0
    }, e));
  }

  _createClass(le, [{
    key: "get",
    value: function get() {
      var e = {};
      return this.each(function (n, r) {
        return e[r] = n.get();
      }), e;
    }
  }, {
    key: "set",
    value: function set(e) {
      for (var n in e) {
        var r = e[n];
        z.und(r) || this.springs[n].set(r);
      }
    }
  }, {
    key: "update",
    value: function update(e) {
      return e && this.queue.push(Pe(e)), this;
    }
  }, {
    key: "start",
    value: function start(e) {
      var n = this.queue;
      return e ? n = Ve(e).map(Pe) : this.queue = [], this._flush ? this._flush(this, n) : (jt(this, n), ze(this, n));
    }
  }, {
    key: "stop",
    value: function stop(e, n) {
      if (e !== !!e && (n = e), n) {
        var r = this.springs;
        pe(Ve(n), function (o) {
          return r[o].stop(!!e);
        });
      } else oe(this._state, this._lastAsyncId), this.each(function (r) {
        return r.stop(!!e);
      });

      return this;
    }
  }, {
    key: "pause",
    value: function pause(e) {
      if (z.und(e)) this.start({
        pause: !0
      });else {
        var n = this.springs;
        pe(Ve(e), function (r) {
          return n[r].pause();
        });
      }
      return this;
    }
  }, {
    key: "resume",
    value: function resume(e) {
      if (z.und(e)) this.start({
        pause: !1
      });else {
        var n = this.springs;
        pe(Ve(e), function (r) {
          return n[r].resume();
        });
      }
      return this;
    }
  }, {
    key: "each",
    value: function each(e) {
      Ut(this.springs, e);
    }
  }, {
    key: "_onFrame",
    value: function _onFrame() {
      var _this13 = this;

      var _this$_events = this._events,
          e = _this$_events.onStart,
          n = _this$_events.onChange,
          r = _this$_events.onRest,
          o = this._active.size > 0,
          s = this._changed.size > 0;
      (o && !this._started || s && !this._started) && (this._started = !0, ut(e, function (_ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
            u = _ref9[0],
            p = _ref9[1];

        p.value = _this13.get(), u(p, _this13, _this13._item);
      }));
      var i = !o && this._started,
          a = s || i && r.size ? this.get() : null;
      s && n.size && ut(n, function (_ref10) {
        var _ref11 = _slicedToArray(_ref10, 2),
            u = _ref11[0],
            p = _ref11[1];

        p.value = a, u(p, _this13, _this13._item);
      }), i && (this._started = !1, ut(r, function (_ref12) {
        var _ref13 = _slicedToArray(_ref12, 2),
            u = _ref13[0],
            p = _ref13[1];

        p.value = a, u(p, _this13, _this13._item);
      }));
    }
  }, {
    key: "eventObserved",
    value: function eventObserved(e) {
      if (e.type == "change") this._changed.add(e.parent), e.idle || this._active.add(e.parent);else if (e.type == "idle") this._active.delete(e.parent);else return;
      kt.onFrame(this._onFrame);
    }
  }, {
    key: "idle",
    get: function get() {
      return !this._state.asyncTo && Object.values(this.springs).every(function (e) {
        return e.idle && !e.isDelayed && !e.isPaused;
      });
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(e) {
      this._item = e;
    }
  }]);

  return le;
}();

function ze(t, e) {
  return Promise.all(e.map(function (n) {
    return wt(t, n);
  })).then(function (n) {
    return be(t, n);
  });
}

function wt(_x2, _x3, _x4) {
  return _wt.apply(this, arguments);
}

function _wt() {
  _wt = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(t, e, n) {
    var r, o, s, i, a, u, p, f, d, m, b, c, P;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            r = e.keys, o = e.to, s = e.from, i = e.loop, a = e.onRest, u = e.onResolve, p = z.obj(e.default) && e.default;
            i && (e.loop = !1), o === !1 && (e.to = null), s === !1 && (e.from = null);
            f = z.arr(o) || z.fun(o) ? o : void 0;
            f ? (e.to = void 0, e.onRest = void 0, p && (p.onRest = void 0)) : pe(Fn, function (P) {
              var l = e[P];

              if (z.fun(l)) {
                var h = t._events[P];
                e[P] = function (_ref29) {
                  var g = _ref29.finished,
                      x = _ref29.cancelled;
                  var S = h.get(l);
                  S ? (g || (S.finished = !1), x && (S.cancelled = !0)) : h.set(l, {
                    value: null,
                    finished: g || !1,
                    cancelled: x || !1
                  });
                }, p && (p[P] = e[P]);
              }
            });
            d = t._state;
            e.pause === !d.paused ? (d.paused = e.pause, On(e.pause ? d.pauseQueue : d.resumeQueue)) : d.paused && (e.pause = !0);
            m = (r || Object.keys(t.springs)).map(function (P) {
              return t.springs[P].start(e);
            }), b = e.cancel === !0 || ke(e, "cancel") === !0;
            (f || b && d.asyncId) && m.push(Me(++t._lastAsyncId, {
              props: e,
              state: d,
              actions: {
                pause: Ft,
                resume: Ft,
                start: function start(P, l) {
                  b ? (oe(d, t._lastAsyncId), l(q(t))) : (P.onRest = a, l(De(f, P, d, t)));
                }
              }
            }));
            _context4.t0 = d.paused;

            if (!_context4.t0) {
              _context4.next = 12;
              break;
            }

            _context4.next = 12;
            return new Promise(function (P) {
              d.resumeQueue.add(P);
            });

          case 12:
            _context4.t1 = be;
            _context4.t2 = t;
            _context4.next = 16;
            return Promise.all(m);

          case 16:
            _context4.t3 = _context4.sent;
            c = (0, _context4.t1)(_context4.t2, _context4.t3);

            if (!(i && c.finished && !(n && c.noop))) {
              _context4.next = 22;
              break;
            }

            P = at(e, i, o);

            if (!P) {
              _context4.next = 22;
              break;
            }

            return _context4.abrupt("return", (jt(t, [P]), wt(t, P, !0)));

          case 22:
            return _context4.abrupt("return", (u && kt.batchedUpdates(function () {
              return u(c, t, t.item);
            }), c));

          case 23:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _wt.apply(this, arguments);
}

function _e(t, e) {
  var n = _objectSpread({}, t.springs);

  return e && pe(Ve(e), function (r) {
    z.und(r.keys) && (r = Pe(r)), z.obj(r.to) || (r = _objectSpread({}, r, {
      to: void 0
    })), Mt(n, r, function (o) {
      return Lt(o);
    });
  }), pt(t, n), n;
}

function pt(t, e) {
  Ut(e, function (n, r) {
    t.springs[r] || (t.springs[r] = n, Et(n, t));
  });
}

function Lt(t, e) {
  var n = new ue();
  return n.key = t, e && Et(n, e), n;
}

function Mt(t, e, n) {
  e.keys && pe(e.keys, function (r) {
    (t[r] || (t[r] = n(r)))._prepareNode(e);
  });
}

function jt(t, e) {
  pe(e, function (n) {
    Mt(t.springs, n, function (r) {
      return Lt(r, t);
    });
  });
}

import * as Be from "react";
import { useContext as Un } from "react";
import { useMemoOne as En } from "@react-spring/shared";

var H = function H(_ref14) {
  var t = _ref14.children,
      e = _objectWithoutProperties(_ref14, ["children"]);

  var n = Un(Ge),
      r = e.pause || !!n.pause,
      o = e.immediate || !!n.immediate;
  e = En(function () {
    return {
      pause: r,
      immediate: o
    };
  }, [r, o]);
  var s = Ge.Provider;
  return Be.createElement(s, {
    value: e
  }, t);
},
    Ge = wn(H, {});

H.Provider = Ge.Provider;
H.Consumer = Ge.Consumer;

function wn(t, e) {
  return Object.assign(t, Be.createContext(e)), t.Provider._context = t, t.Consumer._context = t, t;
}

import { each as ce, is as Ke, deprecateDirectCall as Ln } from "@react-spring/shared";

var fe = function fe() {
  var t = [],
      e = function e(r) {
    Ln();
    var o = [];
    return ce(t, function (s, i) {
      if (Ke.und(r)) o.push(s.start());else {
        var a = n(r, s, i);
        a && o.push(s.start(a));
      }
    }), o;
  };

  e.current = t, e.add = function (r) {
    t.includes(r) || t.push(r);
  }, e.delete = function (r) {
    var o = t.indexOf(r);
    ~o && t.splice(o, 1);
  }, e.pause = function () {
    var _arguments = arguments;
    return ce(t, function (r) {
      return r.pause.apply(r, _toConsumableArray(_arguments));
    }), this;
  }, e.resume = function () {
    var _arguments2 = arguments;
    return ce(t, function (r) {
      return r.resume.apply(r, _toConsumableArray(_arguments2));
    }), this;
  }, e.set = function (r) {
    ce(t, function (o, s) {
      var i = Ke.fun(r) ? r(s, o) : r;
      i && o.set(i);
    });
  }, e.start = function (r) {
    var _this14 = this;

    var o = [];
    return ce(t, function (s, i) {
      if (Ke.und(r)) o.push(s.start());else {
        var a = _this14._getProps(r, s, i);

        a && o.push(s.start(a));
      }
    }), o;
  }, e.stop = function () {
    var _arguments3 = arguments;
    return ce(t, function (r) {
      return r.stop.apply(r, _toConsumableArray(_arguments3));
    }), this;
  }, e.update = function (r) {
    var _this15 = this;

    return ce(t, function (o, s) {
      return o.update(_this15._getProps(r, o, s));
    }), this;
  };

  var n = function n(r, o, s) {
    return Ke.fun(r) ? r(s, o) : r;
  };

  return e._getProps = n, e;
};

function He(t, e, n) {
  var _arguments4 = arguments;
  var r = jn.fun(e) && e;
  r && !n && (n = []);
  var o = Xe(function () {
    return r || _arguments4.length == 3 ? fe() : void 0;
  }, []),
      s = Nt(0),
      i = Dn(),
      a = Xe(function () {
    return {
      ctrls: [],
      queue: [],
      flush: function flush(h, g) {
        var x = _e(h, g);

        return s.current > 0 && !a.queue.length && !Object.keys(x).some(function (A) {
          return !h.springs[A];
        }) ? ze(h, g) : new Promise(function (A) {
          pt(h, x), a.queue.push(function () {
            A(ze(h, g));
          }), i();
        });
      }
    };
  }, []),
      u = Nt(_toConsumableArray(a.ctrls)),
      p = [],
      f = Dt(t) || 0;
  Xe(function () {
    Ye(u.current.slice(t, f), function (h) {
      xe(h, o), h.stop(!0);
    }), u.current.length = t, d(f, t);
  }, [t]), Xe(function () {
    d(0, Math.min(f, t));
  }, n);

  function d(h, g) {
    for (var x = h; x < g; x++) {
      var S = u.current[x] || (u.current[x] = new le(null, a.flush)),
          A = r ? r(x, S) : e[x];
      A && (p[x] = Ot(A));
    }
  }

  var m = u.current.map(function (h, g) {
    return _e(h, p[g]);
  }),
      b = Mn(H),
      c = Dt(b),
      P = b !== c && Ue(b);
  qn(function () {
    s.current++, a.ctrls = u.current;
    var h = a.queue;
    h.length && (a.queue = [], Ye(h, function (g) {
      return g();
    })), Ye(u.current, function (g, x) {
      o !== null && o !== void 0 && o.add(g), P && g.start({
        default: b
      });
      var S = p[x];
      S && (he(g, S.ref), g.ref ? g.queue.push(S) : g.start(S));
    });
  }), Nn(function () {
    return function () {
      Ye(a.ctrls, function (h) {
        return h.stop(!0);
      });
    };
  });
  var l = m.map(function (h) {
    return _objectSpread({}, h);
  });
  return o ? [l, o] : l;
}

function J(t, e) {
  var n = Qn.fun(t),
      _He = He(1, n ? t : [t], n ? e || [] : e),
      _He2 = _slicedToArray(_He, 2),
      _He2$ = _slicedToArray(_He2[0], 1),
      r = _He2$[0],
      o = _He2[1];

  return n || arguments.length == 2 ? [r, o] : r;
}

import { useState as zn } from "react";

var Gn = function Gn() {
  return fe();
},
    Xo = function Xo() {
  return zn(Gn)[0];
};

import { useConstant as Bn, useOnce as Kn } from "@react-spring/shared";

var Wo = function Wo(t, e) {
  var n = Bn(function () {
    return new ue(t, e);
  });
  return Kn(function () {
    return function () {
      n.stop();
    };
  }), n;
};

import { each as Xn, is as qt, useIsomorphicLayoutEffect as Yn } from "@react-spring/shared";

function Qt(t, e, n) {
  var r = qt.fun(e) && e;
  r && !n && (n = []);
  var o = !0,
      s,
      i = He(t, function (a, u) {
    var p = r ? r(a, u) : e;
    return s = p.ref, o = o && p.reverse, p;
  }, n || [{}]);

  if (Yn(function () {
    Xn(i[1].current, function (a, u) {
      var p = i[1].current[u + (o ? 1 : -1)];

      if (he(a, s), a.ref) {
        p && a.update({
          to: p.springs
        });
        return;
      }

      p ? a.start({
        to: p.springs
      }) : a.start();
    });
  }, n), r || arguments.length == 3) {
    var _s;

    var a = (_s = s) !== null && _s !== void 0 ? _s : i[1];
    return a._getProps = function (u, p, f) {
      var d = qt.fun(u) ? u(f, p) : u;

      if (d) {
        var m = a.current[f + (d.reverse ? 1 : -1)];
        return m && (d.to = m.springs), d;
      }
    }, i;
  }

  return i[0];
}

import * as Oe from "react";
import { useContext as Hn, useRef as lt, useMemo as Jn } from "react";
import { is as G, toArray as zt, useForceUpdate as Wn, useOnce as $n, usePrev as Zn, each as j, useIsomorphicLayoutEffect as Je } from "@react-spring/shared";

function Gt(t, e, n) {
  var _arguments5 = arguments;

  var r = G.fun(e) && e,
      _ref15 = r ? r() : e,
      o = _ref15.reset,
      s = _ref15.sort,
      _ref15$trail = _ref15.trail,
      i = _ref15$trail === void 0 ? 0 : _ref15$trail,
      _ref15$expires = _ref15.expires,
      a = _ref15$expires === void 0 ? !0 : _ref15$expires,
      _ref15$exitBeforeEnte = _ref15.exitBeforeEnter,
      u = _ref15$exitBeforeEnte === void 0 ? !1 : _ref15$exitBeforeEnte,
      p = _ref15.onDestroyed,
      f = _ref15.ref,
      d = _ref15.config,
      m = Jn(function () {
    return r || _arguments5.length == 3 ? fe() : void 0;
  }, []),
      b = zt(t),
      c = [],
      P = lt(null),
      l = o ? null : P.current;

  Je(function () {
    P.current = c;
  }), $n(function () {
    return j(c, function (y) {
      m !== null && m !== void 0 && m.add(y.ctrl), y.ctrl.ref = m;
    }), function () {
      j(P.current, function (y) {
        y.expired && clearTimeout(y.expirationId), xe(y.ctrl, m), y.ctrl.stop(!0);
      });
    };
  });
  var h = tr(b, r ? r() : e, l),
      g = o && P.current || [];
  Je(function () {
    return j(g, function (_ref16) {
      var y = _ref16.ctrl,
          T = _ref16.item,
          F = _ref16.key;
      xe(y, m), I(p, T, F);
    });
  });
  var x = [];

  if (l && j(l, function (y, T) {
    y.expired ? (clearTimeout(y.expirationId), g.push(y)) : (T = x[T] = h.indexOf(y.key), ~T && (c[T] = y));
  }), j(b, function (y, T) {
    c[T] || (c[T] = {
      key: h[T],
      item: y,
      phase: "mount",
      ctrl: new le()
    }, c[T].ctrl.item = y);
  }), x.length) {
    var y = -1,
        _ref17 = r ? r() : e,
        T = _ref17.leave;

    j(x, function (F, k) {
      var O = l[k];
      ~F ? (y = c.indexOf(O), c[y] = _objectSpread({}, O, {
        item: b[F]
      })) : T && c.splice(++y, 0, O);
    });
  }

  G.fun(s) && c.sort(function (y, T) {
    return s(y.item, T.item);
  });

  var S = -i,
      A = Wn(),
      V = ne(e),
      _ = new Map(),
      v = lt(new Map()),
      w = lt(!1);

  j(c, function (y, T) {
    var F = y.key,
        k = y.phase,
        O = r ? r() : e,
        U,
        D,
        Jt = I(O.delay || 0, F);
    if (k == "mount") U = O.enter, D = "enter";else {
      var M = h.indexOf(F) < 0;
      if (k != "leave") {
        if (M) U = O.leave, D = "leave";else if (U = O.update) D = "update";else return;
      } else if (!M) U = O.enter, D = "enter";else return;
    }

    if (U = I(U, y.item, T), U = G.obj(U) ? de(U) : {
      to: U
    }, !U.config) {
      var _M = d || V.config;

      U.config = I(_M, y.item, T, D);
    }

    S += i;

    var Z = _objectSpread({}, V, {
      delay: Jt + S,
      ref: f,
      immediate: O.immediate,
      reset: !1
    }, U);

    if (D == "enter" && G.und(Z.from)) {
      var _M2 = r ? r() : e,
          Te = G.und(_M2.initial) || l ? _M2.from : _M2.initial;

      Z.from = I(Te, y.item, T);
    }

    var Wt = Z.onResolve;

    Z.onResolve = function (M) {
      I(Wt, M);
      var Te = P.current,
          B = Te.find(function (Fe) {
        return Fe.key === F;
      });

      if (B && !(M.cancelled && B.phase != "update") && B.ctrl.idle) {
        var Fe = Te.every(function (ee) {
          return ee.ctrl.idle;
        });

        if (B.phase == "leave") {
          var ee = I(a, B.item);

          if (ee !== !1) {
            var Ze = ee === !0 ? 0 : ee;

            if (B.expired = !0, !Fe && Ze > 0) {
              Ze <= 2147483647 && (B.expirationId = setTimeout(A, Ze));
              return;
            }
          }
        }

        Fe && Te.some(function (ee) {
          return ee.expired;
        }) && (v.current.delete(B), u && (w.current = !0), A());
      }
    };

    var ft = _e(y.ctrl, Z);

    D === "leave" && u ? v.current.set(y, {
      phase: D,
      springs: ft,
      payload: Z
    }) : _.set(y, {
      phase: D,
      springs: ft,
      payload: Z
    });
  });
  var C = Hn(H),
      $ = Zn(C),
      L = C !== $ && Ue(C);
  Je(function () {
    L && j(c, function (y) {
      y.ctrl.start({
        default: C
      });
    });
  }, [C]), j(_, function (y, T) {
    if (v.current.size) {
      var F = c.findIndex(function (k) {
        return k.key === T.key;
      });
      c.splice(F, 1);
    }
  }), Je(function () {
    j(v.current.size ? v.current : _, function (_ref18, F) {
      var y = _ref18.phase,
          T = _ref18.payload;
      var k = F.ctrl;
      F.phase = y, m !== null && m !== void 0 && m.add(k), L && y == "enter" && k.start({
        default: C
      }), T && (he(k, T.ref), (k.ref || m) && !w.current ? k.update(T) : (k.start(T), w.current && (w.current = !1)));
    });
  }, o ? void 0 : n);

  var N = function N(y) {
    return Oe.createElement(Oe.Fragment, null, c.map(function (T, F) {
      var _ref19 = _.get(T) || T.ctrl,
          k = _ref19.springs,
          O = y(_objectSpread({}, k), T.item, T, F);

      return O && O.type ? Oe.createElement(O.type, _objectSpread({}, O.props, {
        key: G.str(T.key) || G.num(T.key) ? T.key : T.ctrl.id,
        ref: O.ref
      })) : O;
    }));
  };

  return m ? [N, m] : N;
}

var er = 1;

function tr(t, _ref20, r) {
  var e = _ref20.key,
      _ref20$keys = _ref20.keys,
      n = _ref20$keys === void 0 ? e : _ref20$keys;

  if (n === null) {
    var o = new Set();
    return t.map(function (s) {
      var i = r && r.find(function (a) {
        return a.item === s && a.phase !== "leave" && !o.has(a);
      });
      return i ? (o.add(i), i.key) : er++;
    });
  }

  return G.und(n) ? t : G.fun(n) ? t.map(n) : zt(n);
}

import { each as nr, onScroll as rr, useIsomorphicLayoutEffect as or } from "@react-spring/shared";

var hs = function hs() {
  var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      t = _ref21.container,
      e = _objectWithoutProperties(_ref21, ["container"]);

  var _J = J(function () {
    return _objectSpread({
      scrollX: 0,
      scrollY: 0,
      scrollXProgress: 0,
      scrollYProgress: 0
    }, e);
  }, []),
      _J2 = _slicedToArray(_J, 2),
      n = _J2[0],
      r = _J2[1];

  return or(function () {
    var o = rr(function (_ref22) {
      var s = _ref22.x,
          i = _ref22.y;
      r.start({
        scrollX: s.current,
        scrollXProgress: s.progress,
        scrollY: i.current,
        scrollYProgress: i.progress
      });
    }, {
      container: (t === null || t === void 0 ? void 0 : t.current) || void 0
    });
    return function () {
      nr(Object.values(n), function (s) {
        return s.stop();
      }), o();
    };
  }, []), n;
};

import { onResize as sr, each as ir, useIsomorphicLayoutEffect as ar } from "@react-spring/shared";

var Ps = function Ps(_ref23) {
  var t = _ref23.container,
      e = _objectWithoutProperties(_ref23, ["container"]);

  var _J3 = J(function () {
    return _objectSpread({
      width: 0,
      height: 0
    }, e);
  }, []),
      _J4 = _slicedToArray(_J3, 2),
      n = _J4[0],
      r = _J4[1];

  return ar(function () {
    var o = sr(function (_ref24) {
      var s = _ref24.width,
          i = _ref24.height;
      r.start({
        width: s,
        height: i,
        immediate: n.width.get() === 0 || n.height.get() === 0
      });
    }, {
      container: (t === null || t === void 0 ? void 0 : t.current) || void 0
    });
    return function () {
      ir(Object.values(n), function (s) {
        return s.stop();
      }), o();
    };
  }, []), n;
};

import { useRef as ur, useState as pr } from "react";
import { is as Bt, useIsomorphicLayoutEffect as lr } from "@react-spring/shared";
var cr = {
  any: 0,
  all: 1
};

function Cs(t, e) {
  var _pr = pr(!1),
      _pr2 = _slicedToArray(_pr, 2),
      n = _pr2[0],
      r = _pr2[1],
      o = ur(),
      s = Bt.fun(t) && t,
      i = s ? s() : {},
      _i$to = i.to,
      a = _i$to === void 0 ? {} : _i$to,
      _i$from = i.from,
      u = _i$from === void 0 ? {} : _i$from,
      p = _objectWithoutProperties(i, ["to", "from"]),
      f = s ? e : t,
      _J5 = J(function () {
    return _objectSpread({
      from: u
    }, p);
  }, []),
      _J6 = _slicedToArray(_J5, 2),
      d = _J6[0],
      m = _J6[1];

  return lr(function () {
    var b = o.current,
        _ref25 = f !== null && f !== void 0 ? f : {},
        c = _ref25.root,
        P = _ref25.once,
        _ref25$amount = _ref25.amount,
        l = _ref25$amount === void 0 ? "any" : _ref25$amount,
        h = _objectWithoutProperties(_ref25, ["root", "once", "amount"]);

    if (!b || P && n || typeof IntersectionObserver > "u") return;

    var g = new WeakMap(),
        x = function x() {
      return a && m.start(a), r(!0), P ? void 0 : function () {
        u && m.start(u), r(!1);
      };
    },
        S = function S(V) {
      V.forEach(function (_) {
        var v = g.get(_.target);
        if (_.isIntersecting !== !!v) if (_.isIntersecting) {
          var w = x();
          Bt.fun(w) ? g.set(_.target, w) : A.unobserve(_.target);
        } else v && (v(), g.delete(_.target));
      });
    },
        A = new IntersectionObserver(S, _objectSpread({
      root: c && c.current || void 0,
      threshold: typeof l == "number" || Array.isArray(l) ? l : cr[l]
    }, h));

    return A.observe(b), function () {
      return A.unobserve(b);
    };
  }, [f]), s ? [o, d] : [o, n];
}

function qs(_ref26) {
  var t = _ref26.children,
      e = _objectWithoutProperties(_ref26, ["children"]);

  return t(J(e));
}

import { is as fr } from "@react-spring/shared";

function Bs(_ref27) {
  var t = _ref27.items,
      e = _ref27.children,
      n = _objectWithoutProperties(_ref27, ["items", "children"]);

  var r = Qt(t.length, n);
  return t.map(function (o, s) {
    var i = e(o, s);
    return fr.fun(i) ? i(r[s]) : i;
  });
}

function Ys(_ref28) {
  var t = _ref28.items,
      e = _ref28.children,
      n = _objectWithoutProperties(_ref28, ["items", "children"]);

  return Gt(t, n)(e);
}

import { deprecateInterpolate as Cr } from "@react-spring/shared";
import { is as dr, raf as mr, each as $e, isEqual as hr, toArray as We, frameLoop as gr, getFluidValue as Kt, createInterpolator as yr, Globals as Sr, callFluidObservers as Pr, addFluidObserver as Tr, removeFluidObserver as xr, hasFluidValue as Xt } from "@react-spring/shared";
import { getAnimated as br, setAnimated as Ar, getAnimatedType as Rr, getPayload as Ht } from "@react-spring/animated";

var W =
/*#__PURE__*/
function (_X2) {
  _inherits(W, _X2);

  function W(n, r) {
    var _this16;

    _classCallCheck(this, W);

    _this16 = _possibleConstructorReturn(this, _getPrototypeOf(W).call(this));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this16)), "key", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this16)), "idle", !0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this16)), "calc", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this16)), "_active", new Set());

    _this16.source = n;
    _this16.calc = yr.apply(void 0, _toConsumableArray(r));

    var o = _this16._get(),
        s = Rr(o);

    Ar(_assertThisInitialized(_assertThisInitialized(_this16)), s.create(o));
    return _this16;
  }

  _createClass(W, [{
    key: "advance",
    value: function advance(n) {
      var r = this._get(),
          o = this.get();

      hr(r, o) || (br(this).setValue(r), this._onChange(r, this.idle)), !this.idle && Yt(this._active) && ct(this);
    }
  }, {
    key: "_get",
    value: function _get() {
      var n = dr.arr(this.source) ? this.source.map(Kt) : We(Kt(this.source));
      return this.calc.apply(this, _toConsumableArray(n));
    }
  }, {
    key: "_start",
    value: function _start() {
      var _this17 = this;

      this.idle && !Yt(this._active) && (this.idle = !1, $e(Ht(this), function (n) {
        n.done = !1;
      }), Sr.skipAnimation ? (mr.batchedUpdates(function () {
        return _this17.advance();
      }), ct(this)) : gr.start(this));
    }
  }, {
    key: "_attach",
    value: function _attach() {
      var _this18 = this;

      var n = 1;
      $e(We(this.source), function (r) {
        Xt(r) && Tr(r, _this18), Re(r) && (r.idle || _this18._active.add(r), n = Math.max(n, r.priority + 1));
      }), this.priority = n, this._start();
    }
  }, {
    key: "_detach",
    value: function _detach() {
      var _this19 = this;

      $e(We(this.source), function (n) {
        Xt(n) && xr(n, _this19);
      }), this._active.clear(), ct(this);
    }
  }, {
    key: "eventObserved",
    value: function eventObserved(n) {
      n.type == "change" ? n.idle ? this.advance() : (this._active.add(n.parent), this._start()) : n.type == "idle" ? this._active.delete(n.parent) : n.type == "priority" && (this.priority = We(this.source).reduce(function (r, o) {
        return Math.max(r, (Re(o) ? o.priority : 0) + 1);
      }, 0));
    }
  }]);

  return W;
}(X);

function vr(t) {
  return t.idle !== !1;
}

function Yt(t) {
  return !t.size || Array.from(t).every(vr);
}

function ct(t) {
  t.idle || (t.idle = !0, $e(Ht(t), function (e) {
    e.done = !0;
  }), Pr(t, {
    type: "idle",
    parent: t
  }));
}

var ui = function ui(t) {
  for (var _len6 = arguments.length, e = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    e[_key6 - 1] = arguments[_key6];
  }

  return new W(t, e);
},
    pi = function pi(t) {
  for (var _len7 = arguments.length, e = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    e[_key7 - 1] = arguments[_key7];
  }

  return Cr(), new W(t, e);
};

import { Globals as Ir, frameLoop as Vr, createStringInterpolator as _r } from "@react-spring/shared";
Ir.assign({
  createStringInterpolator: _r,
  to: function to(t, e) {
    return new W(t, e);
  }
});
var di = Vr.advance;
import { createInterpolator as Ui, useIsomorphicLayoutEffect as Ei, useReducedMotion as wi, easings as Li } from "@react-spring/shared";
export * from "@react-spring/types";
export { Ae as BailSignal, le as Controller, X as FrameValue, Ir as Globals, W as Interpolation, qs as Spring, H as SpringContext, fe as SpringRef, ue as SpringValue, Bs as Trail, Ys as Transition, mt as config, Ui as createInterpolator, Li as easings, de as inferTo, pi as interpolate, ui as to, di as update, wr as useChain, Cs as useInView, Ei as useIsomorphicLayoutEffect, wi as useReducedMotion, Ps as useResize, hs as useScroll, J as useSpring, Xo as useSpringRef, Wo as useSpringValue, He as useSprings, Qt as useTrail, Gt as useTransition };